import React from 'react';
import { Container } from 'reactstrap';
import { useTranslation } from 'react-i18next';

interface Props {
  block: boolean;
}

const Unauthorized: React.FC<Props> = ({ block }) => {
  const { t } = useTranslation();
  return (
    <Container className="dashboard">
      <div className="title-content">
        <div className="page-title">
          <h1>{block ? t('noServer') : t('unauthorizedMsg')}</h1>
        </div>
      </div>
    </Container>
  );
};

export default Unauthorized;
